exports.APPLICATION_ID = process.env.APPLICATION_ID
exports.SECURITY_API_URL = process.env.SECURITY_API_URL
exports.SECURITY_API_PRIVATE_KEY = process.env.SECURITY_API_PRIVATE_KEY
// TODO: Client Web API endpoints are being migrated to importscan-rewrite-api
// (IMPORTSCAN_AWS_URL); account-info moved in PLATFORM-188. Move the remaining
// CLIENT_API_URL calls (client-lead, should-track-offline) as their
// rewrite-api equivalents land.
exports.CLIENT_API_URL = process.env.USERS_API_URL
exports.IMPORTSCAN_AWS_URL = process.env.IMPORTSCAN_AWS_URL
exports.APPLICATION_DOMAIN =
  process.env.APPLICATION_DOMAIN || '.importgenius.com'
